import React, { createContext, useContext } from 'react';
import { useUserPermissions } from './legacy';
import type { AppUser, Permissions } from 'shared/state/types';

const Ctx = createContext<Permissions | null>(null);

/** The single useUserPermissions call in the V2 tree. */
export function PermissionsProvider({ user, children }: { user: AppUser; children: React.ReactNode }) {
  const permissions = useUserPermissions(user);
  return <Ctx.Provider value={permissions}>{children}</Ctx.Provider>;
}

export function usePermissions(): Permissions {
  const p = useContext(Ctx);
  if (!p) throw new Error('usePermissions must be used inside <PermissionsProvider>.');
  return p;
}
